import { createListenerMiddleware } from '@reduxjs/toolkit';
import { fetchLookupData } from '@store/features';

export const getUserMiddleware = () => {
  const userMiddleware = createListenerMiddleware();
  userMiddleware.startListening({
    predicate: (action, currentState, previousState) =>
      currentState.session.status !== previousState.session.status &&
      currentState.session.status === 'ok',
    effect: (action, listenerApi) => {
      listenerApi.cancelActiveListeners();
      const session = listenerApi.getState().session;
      listenerApi.dispatch(fetchLookupData({ token: null, userId: session.userId }));
    }
  });
  return userMiddleware;
};
